<!--退款选择-->
<template>
  <pi-content className="white">
    <div class="my-cash-custom">
      <div class="can-refund-number-tag">可退金额（元）</div>
      <div class="text-color-first" style="font-weight: 500; font-size: 0.7rem; padding: 0.34rem 0">{{canRefundMoney}}</div>
      <div class="pi-divider"></div>
      <div class="text-color-third text-size-28 margin-top-normal" style="line-height: 0.4rem">可退金额范围内，您可以输入自定义退款金额。</div>
      <input type="number"
             style="font-weight: 500; font-size: 0.7rem; padding: 0.34rem 0"
             placeholder="" v-model="refundMoney">
      <div class="pi-divider"></div>
      <div class="cell">
        <div class="cell-title">交易流水号</div>
        <div class="cell-content">{{details.serialNumber}}</div>
      </div>
      <div class="cell">
        <div class="cell-title">订单号</div>
        <div class="cell-content">{{details.orderNo}}</div>
      </div>
      <div class="cell">
        <div class="cell-title">充值时间</div>
        <div class="cell-content">{{details.fundTime}}</div>
      </div>
      <div class="cell">
        <div class="cell-title">支付方式</div>
        <div class="cell-content">{{details.paymentwayDesc}}</div>
      </div>
      <div class="cell">
        <div class="cell-title">支付渠道</div>
        <div class="cell-content">{{details.channelDesc}}</div>
      </div>
      <div class="cell">
        <div class="cell-title">充值手机号</div>
        <div class="cell-content">{{details.mobileNo}}</div>
      </div>
      <div class="cell">
        <div class="cell-title">充值金额</div>
        <div class="cell-content">{{details.fundAmount}}元</div>
      </div>
      <div class="cell">
        <div class="cell-title">已退金额</div>
        <div class="cell-content">{{details.fundAmount}}元</div>
      </div>
    </div>
    <div class="button1" @click="onRefundClick">
      申请退款
    </div>
  </pi-content>
</template>

<script>
import { List } from 'vant';
import { customRefund, customRefundDetail } from '@/common/api/index';

export default {
  name: 'my-cash-custom-choose',
  components: {
    [List.name]: List
  },
  data () {
    return {
      canRefundMoney: '',
      refundMoney: '',
      details: {}
    };
  },
  mounted () {
    this.getCustomDetail();
  },
  methods: {
    onRefundClick() {
      if (this.canRefundMoney > this.refundMoney) {
        this.$toast('退款金额不得大于可退款总金额');
        return;
      }
      customRefund({
        accountPkId: this.$testPkId,
        rechargeOrderPkId: '',
        refundAmount: this.$testPkId
      }).then((response) => {
        console.log(response);
        let data = response.data;
        if (data.status === 0 && data.data) {
          this.$router.push('/my/cash/custom/success');
        } else {
          this.$router.push('/my/cash/custom/fail');
        }
      }).catch((error) => {
        console.log(error);
        this.$router.push('/my/cash/custom/fail');
      });
    },
    getCustomDetail() {
      customRefundDetail({
        accountPkId: this.$testPkId
      }).then((response) => {
        console.log(response);
        let data = response.data;
        if (data.status === 0 && data.data) {
          this.details = data.data[0];
          if (this.isNumber(this.details.fundAmount) && this.isNumber(this.details.refundedAmount)) {
            this.canRefundMoney = this.details.fundAmount - this.details.refundedAmount;
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    isNumber(number) {
      return typeof number === 'number';
    }
  }
};
</script>

<style lang="less" scoped>
.my-cash-custom {
  padding: 0.2rem 0.2rem 0.3rem 0.2rem;
}
.cell {
  position: relative;
  padding: 0.2rem 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cell-title {
    color: #999999;
    min-width: 2rem;
  }
  .cell-content {
    color: #666666;
    flex: 1;
    width: 0;
    text-align: end;
  }
}
.button1{
  height: 0.8rem;
  background:rgba(20,204,128,1);
  border-radius:40px;
  text-align: center;
  color: white;
  font-size: 0.34rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.4rem 0.8rem;
}

</style>
